import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DbContext, DbTable } from '../../services/data/dbcontext.service';
import { DeepWellTieIn, MetadataCollection, SeaState, SeaWaterSuction } from '../../models/metadata/metadata.models';
import { OnSiteMovementStatus, OnSiteMovementType } from '../../models/on-site-movement/on-site-movement.models';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class MetadataService {
  config = AppConfig.settings;
  private seaStateTable: DbTable;
  private deepWellTieInTable: DbTable;
  private seaWaterSuctionTable: DbTable;
  private onSiteMovementTypeTable: DbTable;
  private onSiteMovementStatusTable: DbTable;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext
  ) {
    this.seaStateTable = this.dbContext.tables.find(t => t.name === 'SeaStates');
    this.deepWellTieInTable = this.dbContext.tables.find(
      t => t.name === 'DeepWellTieIns'
    );
    this.seaWaterSuctionTable = this.dbContext.tables.find(
      t => t.name === 'SeaWaterSuction'
    );
    this.onSiteMovementTypeTable = this.dbContext.tables.find(
      t => t.name === 'OnSiteMovementTypes'
    );
    this.onSiteMovementStatusTable = this.dbContext.tables.find(
      t => t.name === 'OnSiteMovementStatus'
    );
  }

  public async getMetadata(): Promise<MetadataCollection> {
    const url = `${this.config.apiUrl}api/metadata`;
    const result = await this.http.get<MetadataCollection>(url).toPromise();
    await this.saveSeaStatesLocally(result.seaStates);
    await this.saveDeepWellTieInsLocally(result.deepWellTieIns);
    await this.saveSeaWaterSuctionLocally(result.seaWaterSuctionOptions);
    await this.saveOnSiteMovementStatusLocally(result.onSiteMovementStatuses);
    await this.saveOnSiteMovementTypesLocally(result.onSiteMovementTypes);
    return result;
  }

  private async saveSeaStatesLocally(seaStates: SeaState[]) {
    for (let i = 0; i < seaStates.length; i++) {
      await this.dbContext.addOrUpdate(this.seaStateTable, seaStates[i].id, seaStates[i]);
    }
  }

  public async getSeaStates() {
    return await this.dbContext.getAll(this.seaStateTable);
  }

  private async saveDeepWellTieInsLocally(deepWellTieIns: DeepWellTieIn[]) {
    for (let i = 0; i < deepWellTieIns.length; i++) {
      await this.dbContext.addOrUpdate(this.deepWellTieInTable, deepWellTieIns[i].id, deepWellTieIns[i]);
    }
  }

  public async getDeepWellTieIns() {
    return await this.dbContext.getAll(this.deepWellTieInTable);
  }

  private async saveSeaWaterSuctionLocally(seaWaterSuctionOptions: SeaWaterSuction[]) {
    for (let i = 0; i < seaWaterSuctionOptions.length; i++) {
      await this.dbContext.addOrUpdate(this.seaWaterSuctionTable, seaWaterSuctionOptions[i].id, seaWaterSuctionOptions[i]);
    }
  }

  public async getSeaWaterSuctionOptions() {
    return await this.dbContext.getAll(this.seaWaterSuctionTable);
  }

  private async saveOnSiteMovementTypesLocally(onSiteMovementTypes: OnSiteMovementType[]) {
    for (let i = 0; i < onSiteMovementTypes.length; i++) {
      await this.dbContext.addOrUpdate(this.onSiteMovementTypeTable, onSiteMovementTypes[i].id, onSiteMovementTypes[i])
    }
  }

  public async getOnSiteMovementTypes(): Promise<OnSiteMovementType[]> {
    return await this.dbContext.getAll(this.onSiteMovementTypeTable);
  }

  private async saveOnSiteMovementStatusLocally(onSiteMovementStatus: OnSiteMovementStatus[]) {
    for (let i = 0; i < onSiteMovementStatus.length; i++) {
      await this.dbContext.addOrUpdate(this.onSiteMovementStatusTable, onSiteMovementStatus[i].id, onSiteMovementStatus[i]);
    }
  }

  public async getOnSiteMovementStatus(): Promise<OnSiteMovementStatus[]> {
    return await this.dbContext.getAll(this.onSiteMovementStatusTable);
  }
}



// WEBPACK FOOTER //
// ./src/services/metadata/metadata-service.service.ts